module.exports = __webpack_public_path__ + "img/Mood.4f79b15b.jpg";